import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import AuthService from 'services/AuthService';
import { getFromStorage, removeFromStorage, setToStorage } from 'utils/storageUtils';

export const initialState = {
    loading: false,
    message: '',
    showMessage: false,
    redirect: '',
    token: getFromStorage(AUTH_TOKEN),
}

export const signIn = createAsyncThunk('auth/signIn', async (data, { rejectWithValue }) => {
    const { email, password } = data
    try {
        const response = await AuthService.login({
            Email: email,
            Password: password,
        })
        if (response) {
            const token = response.data.token
            setToStorage(AUTH_TOKEN, response.data.token)
            if (typeof window !== 'undefined') {
                window.location.reload()
            }
            return token
        } else {
            console.log(response)
            return rejectWithValue(response.message)
        }
    } catch (err) {
        if (axios.isAxiosError(err)) {
            if (err.response) {
                // Sunucudan yanıt alındı, ancak status code 200 aralığında değil
                console.log(err.response)
                return rejectWithValue(err.response.data.error || 'Error')
            } else if (err.request) {
                // Request yapıldı ancak yanıt alınamadı
                console.log(err.request)
                return rejectWithValue('No response received from server')
            }
        } else {
            // Başka bir hata oluştu
            console.log(err)
            return rejectWithValue(err.message || 'Error')
        }
    }
})


export const signOut = createAsyncThunk('auth/signOut', async () => {
    removeFromStorage(AUTH_TOKEN)
})

export const forgotPassword = createAsyncThunk('auth/forgotPassword', async (data, { rejectWithValue }) => {
    try {
        const response = await AuthService.forgotPassword(data)
        return [response]
    } catch (err) {
        return rejectWithValue(err.response?.data?.error || 'Error')
    }
})

export const resetPassword = createAsyncThunk('auth/resetPassword', async (data, { rejectWithValue }) => {
    try {
        const response = await AuthService.resetPassword(data)
        return [response]
    } catch (err) {
        return rejectWithValue(err.response?.data?.error || 'Error')
    }
})

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        authenticated: (state, action) => {
            state.loading = false
            state.redirect = '/'
            state.token = action.payload
        },
        showAuthMessage: (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        },
        hideAuthMessage: (state) => {
            state.message = ''
            state.showMessage = false
        },
        signOutSuccess: (state) => {
            state.loading = false
            state.token = null
            state.redirect = '/'
        },
        showLoading: (state) => {
            state.loading = true
        },
        signInSuccess: (state, action) => {
            state.loading = false
            state.token = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(signIn.pending, (state) => {
                state.loading = true
            })
            .addCase(signIn.fulfilled, (state, action) => {
                state.loading = false
                state.redirect = '/'
                state.token = action.payload
            })
            .addCase(signIn.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
            })
            .addCase(signOut.fulfilled, (state) => {
                state.loading = false
                state.token = null
                state.redirect = '/'
            })
            .addCase(signOut.rejected, (state) => {
                state.loading = false
                state.token = null
                state.redirect = '/'
            })
           
           
    },
})

export const { authenticated, showAuthMessage, hideAuthMessage, signOutSuccess, showLoading, signInSuccess } =
    authSlice.actions

export default authSlice.reducer
